





































import {computed, defineComponent, PropType} from "@vue/composition-api";
import {CrumbPage, ProjectEntityInterface, TeamEntityInterface} from "@tool/tool.types";
import {WithProps} from "@base/base.types";

export default defineComponent({
    components: {},
    props: {
        teamOrProject: {
            type: Object as PropType<TeamEntityInterface | WithProps<ProjectEntityInterface, 'team'>>,
            required: false
        },
        pages: {
            type: Array as PropType<CrumbPage[]>,
            required: false
        }
    },
    setup(props) {
        const team = computed<TeamEntityInterface | null>(() => {
            if (!props.teamOrProject) {
                return null;
            }

            if ('team' in props.teamOrProject) {
                return props.teamOrProject.team;
            }

            if ('slug' in props.teamOrProject) {
                return null;
            }

            return props.teamOrProject;
        });

        const project = computed<ProjectEntityInterface | null>(() => {
            if (!props.teamOrProject) {
                return null;
            }

            if ('team' in props.teamOrProject) {
                return props.teamOrProject;
            }

            return null;
        })

        return {
            team,
            project,
        };
    },
});
